/**
 * Escritura de CSV, RFC 4180.
 *
 * Vive aqui y no en `shopping/export.ts` porque desde el 04/09/2026 hay dos
 * clientes: la lista de la compra y la exportacion completa del §8.1. Dos
 * escapadores distintos para el mismo formato es como se consigue que un
 * fichero se abra bien y el otro no, y que nadie sepa por que.
 */

/** Valores que una celda puede llevar. `null` y `undefined` salen como celda vacia. */
export type CsvCell = string | number | boolean | null | undefined;

/**
 * Escapa un campo: comillas dobles alrededor, y dobladas dentro.
 *
 * El retorno de carro cuenta tanto como el salto de linea. Sin el, un campo
 * con `\r\n` —que es lo que escribe Windows en cualquier texto pegado a
 * mano— parte la fila en dos al abrirlo, y la hoja de calculo no avisa: enseña
 * una tabla con una fila de mas y los datos corridos.
 */
export function csvField(valor: CsvCell): string {
  if (valor === null || valor === undefined) return '';
  const texto = typeof valor === 'boolean' ? (valor ? 'si' : 'no') : String(valor);
  return /["\r\n,]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
}

/**
 * Una tabla entera: cabecera y filas.
 *
 * Termina en salto de linea. Un CSV sin salto final lo aceptan casi todos los
 * programas, pero `wc -l` cuenta una linea menos y quien compruebe el fichero
 * desde una consola vera un numero que no cuadra con las filas que exporto.
 */
export function toCsvTable(
  columns: readonly string[],
  rows: readonly (readonly CsvCell[])[],
): string {
  const lineas = [columns.map(csvField).join(',')];
  for (const fila of rows) lineas.push(fila.map(csvField).join(','));
  return `${lineas.join('\n')}\n`;
}
